/*
 * @Author: yi
 * @Date: 2023-11-13 14:31:19
 * @LastEditors: yi
 * @LastEditTime: 2023-11-14 11:43:52
 * @Description: file content
 */
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';
import reportWebVitals from './reportWebVitals';


const contextClass = {
  success: "bg-blue-600",
  error: "bg-red-600",
  info: "bg-gray-600",
  warning: "bg-orange-400",
  default: "bg-indigo-600",
  dark: "bg-white-600 font-gray-300",
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter >
        <App />
        <ToastContainer 
         toastClassName={({ type }) => contextClass[type || "default"] +
         " relative flex p-1 min-h-10 rounded-md justify-between overflow-hidden cursor-pointer"
        }
        autoClose={5000}  />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
